// Shared aria-labelledby target for location filter popovers (LocatorSearch,
// LocationFilter, FlagshipNearestStores). Safe while only one renders per page.
export const LOCATION_DIALOG_TITLE_ID = "location-filter-dialog-title";
